export default "__VITE_ASSET__DD4Ir6IQ__"